import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

export const genericEmploymentOccupationMenuItems: OccupationMenuItem[] = [
  { label: "inputs.employment.employed", value: EmploymentOccupation.Employed },
  {
    label: "inputs.employment.not_employed",
    value: EmploymentOccupation.Unemployed,
  },
  { label: "inputs.employment.retired", value: EmploymentOccupation.Retired },
  { label: "inputs.employment.student", value: EmploymentOccupation.Student },
];
